export default "__VITE_ASSET__BH$5u3Nv__"